'use client';

import {
  Checkbox as ChakraCheckbox,
  CheckboxProps as ChakraCheckboxProps,
  forwardRef,
  Tooltip,
} from '@chakra-ui/react';
import { FieldError } from 'react-hook-form';

interface Props extends ChakraCheckboxProps {
  error?: FieldError;
}

export type CheckboxProps = Props;

export const Checkbox = forwardRef<Props, 'input'>((props, ref) => {
  const { error, children, ...rest } = props;

  const hasError = Boolean(error);

  return (
    <Tooltip
      isDisabled={!hasError}
      hasArrow
      bg="red.500"
      color="white"
      label={error?.message}
      placement="bottom"
      shouldWrapChildren
    >
      <ChakraCheckbox
        ref={ref}
        alignItems="flex-start"
        size="lg"
        spacing="1.5rem"
        variant="network"
        isInvalid={hasError}
        {...rest}
      >
        {children}
      </ChakraCheckbox>
    </Tooltip>
  );
});
